import React, { useState } from 'react';
import { processJobData } from '../services/ApiService';
import './JobInput.css';

const JobInput = ({ onDataFetched, onLoading }) => {
  const [jobNumber, setJobNumber] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!jobNumber.trim()) {
      setError('Please enter a job number');
      return;
    }
    
    setError('');
    onLoading(true);
    
    try {
      console.log(`Fetching job data for job number: ${jobNumber.trim()}`);
      
      // Process job data from API
      const data = await processJobData(jobNumber.trim());
      
      // Log the response data
      console.log('API Response:', data);
      
      // Check if data is an array
      if (Array.isArray(data)) {
        console.log(`Received ${data.length} wells in the response`);
        data.forEach((well, index) => {
          console.log(`Well ${index + 1}:`, well);
        });
      } else {
        console.log('Response is not an array:', data);
      }
      
      // Pass data to parent component
      onDataFetched(data);
    } catch (error) {
      console.error('Error fetching job data:', error);
      setError(`Failed to fetch job data: ${error.message}`);
    } finally {
      onLoading(false);
    }
  };

  return (
    <div className="job-input">
      <div className="job-input-header">
        <h2>FracFocus XML Generator</h2>
        <p>Enter your job number to get started</p>
      </div>
      
      <form className="job-input-form" onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        
        <div className="form-group">
          <label htmlFor="jobNumber">Job Number</label>
          <input
            type="text"
            id="jobNumber"
            className="form-control"
            value={jobNumber}
            onChange={(e) => setJobNumber(e.target.value)}
            placeholder="Enter job number"
          />
        </div>
        
        <button type="submit" className="submit-button">
          Fetch Job Data
        </button>
      </form>
      
      <div className="job-input-help">
        <h3>How to use this tool:</h3>
        <ol>
          <li>Enter your job number in the field above and click "Fetch Job Data".</li>
          <li>Select the well(s) you want to generate XML for.</li>
          <li>Review and edit the chemical disclosure information if needed.</li>
          <li>Generate and download your FracFocus XML file.</li>
        </ol>
        <p className="note">Note: This tool connects to the FracPro API to retrieve job data. Make sure you have a valid job number.</p>
      </div>
    </div>
  );
};

export default JobInput;
